<div class="dx-fieldset">
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Prompt' | translate }}</div>
    <div class="dx-field-value">
      <div style="display: flex">
        <dx-select-box
          [items]="prompts"
          [(selectedItem)]="prompt"
          displayExpr="name"
          valueExpr="id"
          (onSelectionChanged)="selectedPromptChanged()"
        />
        <dx-button *ngIf="prompt" icon="edit" (onClick)="openEditor()"/>
        <dx-button *ngIf="prompt" icon="trash" (onClick)="deleteConfig()"/>
        <dx-button icon="add" (onClick)="openCreate()"/>
      </div>
    </div>
  </div>

  <div class="dx-field" *ngIf="prompt && prompt?.client != 'nextpim'">
    Sie nutzen Ihre eigenen OPEN-AI-Credentials bitte informieren Sie sich im Vorfeld über die Kosten, die bei der
    Nutzung je API-Call entstehen. Mit dem "Starten" der Funktion entstehen unweigerlich Kosten.
  </div>

  <div class="dx-card mb-4" *ngIf="prompt?.client == 'nextpim'">
    <div class="dx-fieldset">
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Kosten pro Text' | translate }}</div>
        <div class="dx-field-value">
          <dx-number-box
            [readOnly]="true"
            format="#,##0.## €"
            [value]="invoiceSetting.pricePerOpenAi"
          ></dx-number-box>
        </div>
      </div>
      <div class="p-2 flex-fill">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Benutztes Limit' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.usedLimit"></dx-number-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Limit' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.limit"></dx-number-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Freibetrag' | translate }}</div>
          <div class="dx-field-value">
            <dx-number-box [readOnly]="true" format="#,##0.## €" [(value)]="invoiceSetting.allowance"></dx-number-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<np-dialog
  [popupWidth]="'75%'"
  [popupHeight]="'75%'"
  [popupTitle]="'Info' | translate"
  [(popupVisible)]="editorVisible"
>
  <div slot="content" class="w-100 h-100">
    <aiprompt-editor [(prompt)]="prompt" *ngIf="editorVisible"/>

    <np-dialog-button
      slot="toolbar"
      toolbar="bottom"
      location="after"
      widget="dxButton"
      [options]="{ text: 'Abbrechen' | translate, onClick: onCancelEdit }"
    />
    <np-dialog-button
      slot="toolbar"
      toolbar="bottom"
      location="after"
      widget="dxButton"
      [options]="{ text: 'Speichern' | translate, type: 'default', onClick: onSaveEdit }"
    />
  </div>
</np-dialog>
